import { Notyf } from "notyf";

let notyfInstance: Notyf | null = null;

function createNotyf() {
  return new Notyf({
    duration: 4000,
    position: {
      x: "right",
      y: "bottom",
    },
  });
}

export default function useNotyf() {
  if (!notyfInstance) {
    notyfInstance = createNotyf();
  }
  return notyfInstance;
}
